<template>
  <div class="name-badge-container" :class="{ 'is-inactive': !isActive }">
    <i :class="isActive ? 'el-icon-user' : 'el-icon-warning-outline'"></i>
    <span class="badge-text">{{ accountName }}</span>
  </div>
</template>

<script>
export default {
  name: 'NameBadge',
  props: {
    accountName: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
/* Estilo Base (Activo - Azul) */
.name-badge-container {
  display: inline-flex;
  align-items: center;
  background: #f0f7ff;
  color: #2e6da4;
  padding: 6px 14px;
  border-radius: 16px;
  border: 1px solid #d1e9ff;
  font-size: 13px;
  font-weight: bold;
  transition: all 0.3s ease; /* Suaviza el cambio de color */
}

/* Estilo Inactivo (Rojo) */
.name-badge-container.is-inactive {
  background: #fef0f0; /* Rojo muy claro */
  color: #f56c6c;      /* Rojo estándar de Element UI (Danger) */
  border-color: #fde2e2;
}

.name-badge-container i {
  margin-right: 8px;
  font-size: 14px;
}

.badge-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 350px;
}
</style>
